"use client";

import Copyright from "@/components/Copyright";
import Signature from "@/components/Signature";

function Bottom() {
  return (
    <div>
      {/* Separator line between Footer and Bottom */}
      <div className="border-bottom-default"></div>
      
      <div className="container py-4 border-side-default">
        <div className="flex flex-wrap justify-between items-center">
          <div className="w-full md:w-auto">
            <Copyright />
          </div>
          <div className="w-full md:w-auto mt-2 md:mt-0">
            <Signature />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bottom;